import { makeStyles, Theme } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: Theme) => ({
  root: {
    height: 30,
    display: "flex",
    alignItems: "center"
  },
  readyForExamButton: {
    textTransform: "capitalize",
    fontSize: 11,
    borderRadius: 100,
    padding: "2px 10px",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      borderRadius: 4,
      padding: "4px 10px"
    },
    "& .MuiButton-label": {
      whiteSpace: "nowrap"
    }
  },
  sentRequestText: {
    fontSize: 11,
    fontStyle: "italic",
    color: theme.palette.secondary.dark,
    whiteSpace: "nowrap"
  }
}));
